module.exports = __webpack_public_path__ + "static/media/DINOT-Light.2176b69e.woff2";